module.exports = __webpack_public_path__ + "img/btn_funSet.feaa6331.svg";